import { isLocaleFormat } from '@edicom/common/number/isLocaleFormat';

export default function numberService() {
  return function generate(viewField, engineApi) {
    const element = engineApi.field.generateNumber(viewField, engineApi);

    if (viewField.metadata.mask) {
      element.addAttribute(isLocaleFormat(viewField.metadata.mask) ? 'locale-format' : 'mask', viewField.metadata.mask);
    }

    if (viewField.metadata.currency) {
      element.addAttribute('currency', viewField.metadata.currency);
    }

    if (viewField.metadata.type) {
      element.addAttribute('type', viewField.metadata.type);
    }

    return element;
  };
}
